import { getUserId, getUsername } from '../../services/alth';

const PREFIXO = '[cartazes-oferta]';

/**
 * Observabilidade da tela de Cartazes de Oferta — apenas rastro no console do
 * navegador (decisão de produto: sem persistência / sem tela de auditoria).
 * Cada evento carrega quem disparou (`usuarioId`/`usuario`) e o horário.
 *
 * Eventos usados:
 *  - `abrir_selecao`  { total, ids }        — abriu o diálogo de cópias
 *  - `gerar_inicio`   { total, ids }        — confirmou e começou a montar o PDF
 *  - `gerar_sucesso`  { total }             — PDF entregue ao visualizador
 *  - `gerar_erro`     { erro, contexto? }   — falhou em qualquer etapa
 *  - `sem_descricao`  { ids, nomes }        — produtos ignorados por falta de cartaz
 */
export function registrarLogCartaz(evento, dados = {}) {
  // eslint-disable-next-line no-console
  console.info(PREFIXO, evento, {
    ...dados,
    usuarioId: getUserId(),
    usuario: getUsername(),
    em: new Date().toISOString(),
  });
}
